import { BTooltip } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBTooltip = createEgBootstrapProxy("EgBTooltip", BTooltip);
